const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,//默认大小
  socketConnect: state => state.app.socketConnect,//socket连接状态
  operator: state => state.user.operator,//操作员
  menus: state => state.user.menus,//菜单
  locale: state => state.app.locale,//默认语言
  mapType: state => state.app.mapType,//地图类型
  mapKey: state => state.app.mapKey,//地图key
  energyTypes: state => state.user.energyTypes,//能源类型清单
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  permission_routes: state => state.permission.addRoutes,//有权限的路由地址
}
export default getters
